import { LoadingListEntityProfile } from "Explore/Components";
import styles from "./UnitScholarAndPeers.module.scss";
import { getUnitPublicationsById } from "Explore/Services/Unit";
import PublicationItem from "Explore/Components/PublicationItem";
import { Empty } from "antd";
import useExploreInfo from "Hooks/useExploreInfo";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import _ from "lodash";
import SortSelect, { SORT_TYPE } from "Explore/Components/SortSelect";
import InfinityPagination, {
  TOTAL_PAGE_PER_FETCH,
} from "Explore/Components/Pagination/InfinityPagination";

const UnitPublicationList = () => {
  const { unit_id } = useExploreInfo();
  const { selectedKeywords, timeFilter } =
    useSelector((state) => state.conceptState) || {};
  const [data, setData] = useState({ data: [], isLoading: false });
  const [pagination, setPagination] = useState({
    page: 1,
    rowsPerPage: 20,
  });
  const [hasNextPage, setHasNextPage] = useState(true);
  const [currentMaxPage, setCurrentMaxPage] = useState(0);
  const [sortData, setSortData] = useState({
    orderBy: null,
    order: null,
  });

  const prevFilter = useRef({});

  useEffect(() => {
    const _prevFilter = prevFilter.current;
    if (
      !_.isEqual(_prevFilter, {
        unit_id,
        selectedKeywords,
        timeFilter,
        page: pagination.page,
        rowsPerPage: pagination.rowsPerPage,
        orderBy: sortData.orderBy,
        order: sortData.order,
      })
    ) {
      let newPagination = { ...pagination };
      let newData = { ...data.data };
      if (
        _prevFilter.unit_id !== unit_id ||
        _prevFilter.selectedKeywords !== selectedKeywords ||
        _prevFilter.rowsPerPage !== pagination.rowsPerPage ||
        _prevFilter.timeFilter !== timeFilter ||
        _prevFilter.orderBy !== sortData.orderBy ||
        _prevFilter.order !== sortData.order
      ) {
        newData = {};
        newPagination.page = 1;
      }
      const pageToCompute = newPagination.page - 1;
      let pageToFetch = pageToCompute;
      for (
        let i = pageToCompute;
        i < pageToCompute + TOTAL_PAGE_PER_FETCH + 1;
        i++
      ) {
        pageToFetch = i;
        if (!newData[i]) {
          break;
        }
      }
      const numberOfPageToFetch =
        pageToCompute + TOTAL_PAGE_PER_FETCH - pageToFetch;
      if (!!numberOfPageToFetch) {
        setData({ data: newData, isLoading: pageToFetch === pageToCompute });
        getUnitPublicationsById({
          id: unit_id,
          keyword: selectedKeywords,
          timeFilter,
          orderBy: sortData.orderBy,
          order: sortData.order,
          page: pageToCompute,
          rowsPerPage: newPagination.rowsPerPage,
          numPages: numberOfPageToFetch,
        })
          .then((res) => {
            let i = 0;
            for (; i < numberOfPageToFetch; i++) {
              const pageData = res.results.slice(
                i * pagination.rowsPerPage,
                (i + 1) * pagination.rowsPerPage
              );
              if (pageData.length > 0) {
                newData[pageToFetch + i] = pageData;
              } else {
                break;
              }
            }
            setData({
              data: newData,
              isLoading: false,
            });
            setCurrentMaxPage((prev) => Math.max(prev, pageToFetch + i));
            setHasNextPage(res.has_next_page);
            setPagination(newPagination);
          })
          .catch(() => {
            setData({ data: [], isLoading: false });
            setPagination(newPagination);
            setHasNextPage(false);
            setCurrentMaxPage(0);
          });
      }

      prevFilter.current = {
        unit_id,
        selectedKeywords,
        timeFilter,
        page: newPagination.page,
        rowsPerPage: newPagination.rowsPerPage,
        orderBy: sortData.orderBy,
        order: sortData.order,
      };
    } else {
      prevFilter.current = {
        unit_id,
        selectedKeywords,
        timeFilter,
        page: pagination.page,
        rowsPerPage: pagination.rowsPerPage,
        orderBy: sortData.orderBy,
        order: sortData.order,
      };
    }
  }, [
    pagination.page,
    pagination.rowsPerPage,
    unit_id,
    selectedKeywords,
    timeFilter,
    sortData,
  ]);

  return (
    <div className={styles["list__wrapper"]}>
      <SortSelect
        sortData={sortData}
        setSortData={setSortData}
        sortType={SORT_TYPE.PUBLICATION}
        hasOrderType
        loading={data.isLoading}
      />
      <LoadingListEntityProfile
        isLoading={data.isLoading}
        component={
          data.data[pagination.page - 1]?.length > 0 ? (
            data?.data[pagination.page - 1].map((item, index) => {
              return <PublicationItem key={index} data={item} />;
            })
          ) : (
            <Empty description="No Publication Found." />
          )
        }
        componentNum={10}
        rows={2}
        avatar={true}
      />
      <InfinityPagination
        pagination={{ ...pagination }}
        setPagination={setPagination}
        sizeChanger
        hasNextPage={hasNextPage}
        currentMaxPage={currentMaxPage}
        isLoading={data.isLoading}
      />
    </div>
  );
};

export default UnitPublicationList;
